function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "8",
  height: "47",
  viewBox: "0 0 8 47",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "map/Abschnitt/Zustand",
  transform: "translate(-123 -401)",
  stroke: "#979797",
  strokeWidth: ".5"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(38 385)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65.719 36.272H76.34a11 11 0 017.776 3.219l2.246 2.242a3 3 0 004.242 0l2.246-2.242a11 11 0 017.776-3.22h11.956",
  id: "Path-2-Copy",
  transform: "matrix(0 1 1 0 49.71 -49.71)"
}))))));